import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ResourceService } from 'src/app/common-cms-service/resource.service';
import { FormsModule } from '@angular/forms';

export interface DigitalResource {

  id: number;
  slug: string;
  title: string;
  description: string;
  category: string;
  level: string;
  icon: string;
  colorKey: string;
  fileType: string;
  fileSize: string;
  fileName: string;
  fileId: string;
  fileUrl: string;
  price: number;
  salePrice?: number | null;
  downloads: number;

}

export interface DriveProductMeta {
  fileName: string;
  slug?: string;
  title: string;
  description: string;
  category: string;
  level: string;
  icon: string;
  colorKey: string;
  price: number;
  salePrice?: number;
  downloads: number;
}

@Component({
  selector: 'app-digital-downloads',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  templateUrl: './digital-downloads.component.html',
  styleUrl: './digital-downloads.component.css',
})
export class DigitalDownloadsComponent {

loading = false;

  resources = [];

  filteredResources = [];

  searchText = '';

  selectedFilter = 'ALL';

  constructor(

    private resourceService: ResourceService,

    private router: Router

  ) { }

  ngOnInit() {

    this.getResources();

  }

  getResources() {

    this.loading = true;

    this.resourceService

      .getResources()

      .subscribe(

        (response: any) => {

          this.loading = false;

          this.resources = response.data || [];

          this.filteredResources = this.resources;

        },

        error => {

          this.loading = false;

          console.log(error);

        }

      );

  }

  searchResources() {

    var search = this.searchText.toLowerCase();

    this.filteredResources = this.resources.filter((item: any) => {

      var matchSearch =

        item.name.toLowerCase().indexOf(search) > -1 ||

        item.title.toLowerCase().indexOf(search) > -1;

      var matchFilter = true;

      if (this.selectedFilter == 'FREE') {

        matchFilter = item.price == 0;

      }

      if (this.selectedFilter == 'PAID') {

        matchFilter = item.price > 0;

      }

      return matchSearch && matchFilter;

    });

  }

  changeFilter(filter) {

    this.selectedFilter = filter;

    this.searchResources();

  }

  openResource(resource) {

    this.router.navigate([

      '/digital-download',

      resource.slug

    ]);

  }


}
